import { render } from "./otherHisSubject.vue?vue&type=template&id=0a06aec5&scoped=true"
import script from "./otherHisSubject.vue?vue&type=script&lang=js"
export * from "./otherHisSubject.vue?vue&type=script&lang=js"

import "./otherHisSubject.vue?vue&type=style&index=0&id=0a06aec5&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a06aec5"]])

export default __exports__